/* eslint-disable max-len */
import React, { Fragment, useRef, useState } from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { useSelector } from 'react-redux';
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate';

const Table = ({
    pageNumber,
    getListData,
    setToastErrorMessage,
    handleOnClickSort,sortValue,
    searchParams, startDate, endDate,
    setConfirmationState, email, setLoading }) => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const selectedRef = useRef();
    const PurchaseOrderList = useSelector(state => state.purchaseOrderListSlice);
    const { List } = PurchaseOrderList
    const urlParams = new URLSearchParams(window.location.search);


    const branchUrl = urlParams.get("sort");
    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }
    /**
     * The function handles sorting based on a given key and current sort value.
     */

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    console.log('--'+startDate+'--'+endDate)
    return (<>
        <div className='-mx-1'>
            <div className='text-center absolute w-full'>PO Date from <span className="font-semibold">{searchParams?.get('start_date') === null ?  formatAdjustedDate(startDate) : formatAdjustedDate(searchParams?.get('start_date'))}</span> to <span className="font-semibold">{searchParams?.get('end_date') === null ?  formatAdjustedDate(endDate, true) : formatAdjustedDate(searchParams?.get('end_date'))}</span></div>
            <div className={`flex overflow-auto ${List?.data?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1 topHeading`} id="search-result" >
                <table aria-label="Outside Table" className="w-full" id='admin-table'>
                    <thead>
                        <tr>
                            <th id= "PO Date" class="w-[12%]" onClick={() => {handleSort('po_date')}}>
                                <span >PO Date
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "po_date" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th id= "PO Number" class="w-[11%]" onClick={() => {handleSort('po_number')}}>
                                <span >PO #
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "po_number" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[11%]">
                                <span class="flex items-center justify-end">PO Amount
                                </span>
                            </th>
                            <th id="Vendor Name" class="w-[18%]" onClick={() => {handleSort('vendor_name')}}>
                                <span >Vendor Name
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "vendor_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th id="Delivery Date" class="w-[13%]" onClick={() => {handleSort('delivery_date')}}>
                                <span >Delivery Date
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "delivery_date" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th id="Status" class="w-[17%]" onClick={() => {handleSort('status')}}>
                                <span >Status
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "status" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[8%]">
                                <span class="flex items-center justify-center">Actions
                                </span>
                            </th>
                        </tr>
                        <tr aria-colspan="7" class="h-1"></tr>

                    </thead>
                    <tbody>
                        {List?.data?.map((item, index = 0) => (
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    setConfirmationState={setConfirmationState}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    email={email}
                                    searchParams={searchParams}
                                    getListData={getListData}
                                    setLoading={setLoading}
                                    setToastErrorMessage={setToastErrorMessage}
                                />
                            </Fragment>
                        ))}

                    </tbody>
                    {List?.data?.length === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No Purchase Orders added yet.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div >

    </>
    );
}

export default Table;
